import {
  USER_LOADING,
  USER_LOADED,
  MENU_LOADER,
  AUTH_ERROR,
  CHANGE_AVATAR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT_SUCCESS,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  UPDATE_PASSWORD_BY_MOBILE_FAIL,
  UPDATE_PASSWORD_BY_MOBILE_SUCCESS,
} from "../actions/types";

const initialState = {
  access: localStorage.getItem("access"),
  refresh: localStorage.getItem("refresh"),
  isAuthenticated: true,
  isLoading: false,
  index_url: localStorage.getItem("indexUrl") || "/",
  logoUrl: localStorage.getItem("logoUrl") || "",
  username: localStorage.getItem("username"),
  company_name: localStorage.getItem("company_name"),
  avatar: "",
  menuList: []
};


const baseURL = process.env.REACT_APP_BASE_URL

export default function (state = initialState, action) {
  switch (action.type) {
    case CHANGE_AVATAR:
      return {
        ...state,
        avatar: action.avatar,
      };
    case USER_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case USER_LOADED:
      return {
        ...state,
        ...action.payload,
        isAuthenticated: true,
        index_url: localStorage.getItem("indexUrl") || "/",
        logoUrl: localStorage.getItem("logoUrl") || "",
        isLoading: false,
      };
    case LOGIN_SUCCESS:
    case REGISTER_SUCCESS:
    case UPDATE_PASSWORD_BY_MOBILE_SUCCESS:
      localStorage.setItem("access", action.payload.access);
      localStorage.setItem("refresh", action.payload.refresh);
      localStorage.setItem("applicationId", action.payload.application_id);
      localStorage.setItem("indexUrl", action.payload.index_url);
      localStorage.setItem("logoUrl", action.payload.application_logo_url);
      let user = decodeURIComponent(
        escape(window.atob(action.payload.access.split(".")[1]))
      );
      let username = JSON.parse(user).user_username;
      const xhr = new XMLHttpRequest();
      var token = action.payload.access;
      console.log(111111, action.payload, token)
      var url = baseURL + "/user/?username=" + username;
      xhr.open("get", url, false); // 第三个参数为是否开启异步请求
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.setRequestHeader("Authorization", "Bearer " + token);
      xhr.send(null);
      localStorage.setItem("username", username);
      localStorage.setItem(
        "company_name",
        JSON.parse(xhr.responseText).results[0].company_name
      );
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isAuthenticated: true,
        username: username,
        company_name: JSON.parse(xhr.responseText).results[0].company_name,
      };
    case AUTH_ERROR:
    case LOGIN_FAIL:
    case REGISTER_FAIL:
    case UPDATE_PASSWORD_BY_MOBILE_FAIL:
    case LOGOUT_SUCCESS:
      localStorage.removeItem("access");
      localStorage.removeItem("refresh");
      localStorage.removeItem("username");
      localStorage.removeItem("company_name");
      return {
        ...state,
        access: null,
        refresh: null,
        isAuthenticated: false,
        isLoading: false,
        username: null,
      };
    case MENU_LOADER:
      return {
        ...state,
        menuList: action.menuList
      }
    default:
      return state;
  }
}
